export default __webpack_public_path__ + "static/media/hogwarts-2.508ceff0.jpg";